import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import useGetProductDropdown from '../CustomHooks/useGetProductDropdown';
import useGetSpeciesDropdown from '../CustomHooks/useGetSpeciesDropdown';
import useDestinationDropdown from '../CustomHooks/useGetDestinationDropdown';
import useInfoDropdowns from '../CustomHooks/useInfoDropdowns';
import useHazrdsDropdown from '../CustomHooks/useHazardsDropdown';
import useSageCustomers from '../CustomHooks/useSageCustomers';

const zeroOneOptions = [
  { value: '1', label: 'Yes' },
  { value: '0', label: 'No' },
  { value: '', label: 'Not Assessed' },
];
const yesNoOptions = [
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' },
  { value: '', label: 'Not Assessed' },
];
let checkListInputKeys = [
  { name: 'bankAccountDetails', typeOfInp: 'select', label: 'Bank Account Details', dropDownData: zeroOneOptions },
  {
    name: 'dropPinUpdatedonWhatsApp',
    typeOfInp: 'select',
    label: 'Drop Pin Updated on WhatsApp',
    dropDownData: zeroOneOptions,
  },
  {
    name: 'dropPinUpdatedonGoogleMaps',
    typeOfInp: 'select',
    label: 'Drop Pin Updated on Google Maps',
    dropDownData: zeroOneOptions,
  },
  { name: 'safetyStatement', typeOfInp: 'select', label: 'Safety Statement', dropDownData: zeroOneOptions },
  {
    name: 'copyoffellinglicensesattached',
    typeOfInp: 'select',
    label: 'Copy of Felling Licenses Attached',
    dropDownData: zeroOneOptions,
  },
  {
    name: 'serviceItemsforMachineandMachineServicesUptodate',
    typeOfInp: 'select',
    label: 'Service Items for Machine and Machine Services Upto date',
    dropDownData: zeroOneOptions,
  },
  {
    name: 'confirmCertifiedFireExtinguisheronsite',
    typeOfInp: 'select',
    label: 'Confirm Certified Fire Extinguisher Onsite',
    dropDownData: zeroOneOptions,
  },
  { name: 'safetySignserected', typeOfInp: 'select', label: 'Safety Signs Erected', dropDownData: zeroOneOptions },
  { name: 'siteMonitoringForms', typeOfInp: 'select', label: 'Site Monitoring Forms', dropDownData: zeroOneOptions },
  {
    name: 'googleHarvestPlancompleted',
    typeOfInp: 'select',
    label: 'Google Harvest Plan Completed',
    dropDownData: zeroOneOptions,
  },
  {
    name: 'jotformHarvestPlansenttoOperator',
    typeOfInp: 'select',
    label: 'Jotform Harvest Plan Sent To Operator',
    dropDownData: zeroOneOptions,
  },
];
let infoOptionInputKeys = [
  {
    name: 'descriptionType',
    keyName: 'SiteDescriptionType',
    typeOfInp: 'select',
    label: 'Description Type',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'standingType',
    typeOfInp: 'select',
    label: 'Standing Type',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'urea',
    typeOfInp: 'select',
    label: 'Urea',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
    dropDownData: yesNoOptions,
  },
  {
    name: 'timberQuality',
    typeOfInp: 'select',
    label: 'Timber Quality',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'access',
    typeOfInp: 'select',
    label: 'Access',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
  },
];
let siteVolumeOptionInputKeys = [
  {
    name: 'averageTree',
    typeOfInp: 'input',
    label: 'Average tree',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'treesPerHectare',
    typeOfInp: 'input',
    label: 'Trees Per Ha',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'percentOfForestCovered',
    typeOfInp: 'input',
    label: '%age of Forest Covered',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'siteVolAreaInHa',
    typeOfInp: 'input',
    label: 'Site Volume Area In Ha',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'totalVolume',
    typeOfInp: 'input',
    label: 'Total Volume',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'totalTons',
    typeOfInp: 'input',
    label: 'Total Tons',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'totalVolume',
    typeOfInp: 'input',
    label: 'Total Volume',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'totalTonsPerHa',
    typeOfInp: 'input',
    label: 'Total Tons Per Ha',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'totalVolPerHa',
    typeOfInp: 'input',
    label: 'Total Volume Per Ha',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
];
let geoLocationInputKeys = [
  {
    name: 'travelRouteDropPinLink',
    typeOfInp: 'input',
    label: 'Travel Route Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'entranceDropPinLink',
    typeOfInp: 'input',
    label: 'Entrance Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'timberDropPinLink',
    typeOfInp: 'input',
    label: 'Timber Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'timber2DropPinLink',
    typeOfInp: 'input',
    label: 'Timber 2 Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'timber3DropPinLink',
    typeOfInp: 'input',
    label: 'Timber 3 Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'stackingArea1DropPinLink',
    typeOfInp: 'input',
    label: 'Stacking Area 1 Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'stackingArea2DropPinLink',
    typeOfInp: 'input',
    label: 'Stacking Area 2 Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'turntable1DropPinLink',
    typeOfInp: 'input',
    label: 'Turntable 1 Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'turntable2DropPinLink',
    typeOfInp: 'input',
    label: 'Turntable 2 Drop Pin Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'machineDropoffAreaLink',
    typeOfInp: 'input',
    label: 'Machine Drop-off Area Link',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'dropPinVia',
    typeOfInp: 'input',
    label: 'Drop Pin Via',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'dropPinForestGate',
    typeOfInp: 'input',
    label: 'Drop Pin Forest Gate',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
  {
    name: 'dropPinTimberLocation',
    typeOfInp: 'input',
    label: 'Drop Pin Timber Location',
    textFieldType: 'url',
    isTextArea: false,
    width: 12,
  },
];
let hazardsInputKeys = [
  {
    name: 'powerlines',
    typeOfInp: 'select',
    label: 'Powerlines',
    dropDownData: yesNoOptions,
    width: 4,
  },

  {
    name: 'streamsDrains',
    typeOfInp: 'select',
    label: 'Streams/Drains',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'undergroundCables',
    typeOfInp: 'select',
    label: 'Underground Cables',
    dropDownData: yesNoOptions,
    width: 4,
  },
  {
    name: 'groundSlope',
    typeOfInp: 'select',
    label: 'Ground Slope',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'groundCondition',
    typeOfInp: 'select',
    label: 'Ground Condition',
    textFieldType: 'text',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'other',
    typeOfInp: 'input',
    label: 'Other',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
  },
  // {
  //   name: 'roadSlope',
  //   typeOfInp: 'input',
  //   label: 'Road Slope',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 6,
  // },
  // {
  //   name: 'roadCondition',
  //   typeOfInp: 'input',
  //   label: 'Road Condition',
  //   textFieldType: 'text',
  //   isTextArea: false,
  //   width: 6,
  // },
  {
    name: 'powerlines_2',
    typeOfInp: 'select',
    label: 'Powerlines (Secondary)',
    dropDownData: yesNoOptions,
    width: 6,
  },
  {
    name: 'streamsDrains_2',
    typeOfInp: 'select',
    label: 'Streams/Drains (Secondary)',
    dropDownData: yesNoOptions,
    width: 6,
  },

  {
    name: 'other_2',
    typeOfInp: 'input',
    label: 'Other (Secondary)',
    textFieldType: 'text',
    isTextArea: true,
    width: 12,
  },
];
let productsInputKeys = [
  {
    name: 'products',
    typeOfInp: 'select', // 🔧 change from 'input' to 'select'
    label: 'Products',
    width: 4,
    dropdownOptionsName: 'products', // 🔧 link to your fetched dropdown
  },
  {
    name: 'subCompartmentName',
    typeOfInp: 'select', // 🔧 change from 'input' to 'select'
    label: 'Sub Compartment Name',
    width: 6,
    dropdownOptionsName: 'subCompartmentName', // 🔧 link to your fetched dropdown
  },
  {
    name: 'productsPercent',
    typeOfInp: 'input',
    label: 'Products Percent',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'productsDestination',
    typeOfInp: 'select',
    label: 'Products Destination',
    width: 4,
    dropdownOptionsName: 'productsDestination',
  },
  {
    name: 'customerName',
    typeOfInp: 'select',
    label: 'Customer Name',
    width: 4,
    dropdownOptionsName: 'customer',
  },
  {
    name: 'productsPricePerTonne',
    typeOfInp: 'input',
    label: 'Price Per Tonne',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
];
let speciesInputKeys = [
  {
    name: 'species',
    typeOfInp: 'select',
    label: 'Species',
    width: 12,
  },
  {
    name: 'subCompartmentName',
    typeOfInp: 'select', // 🔧 change from 'input' to 'select'
    label: 'Sub Compartment Name',
    width: 6,
    dropdownOptionsName: 'subCompartmentName', // 🔧 link to your fetched dropdown
  },
  {
    name: 'areaInHa',
    typeOfInp: 'input',
    label: 'Area (Ha)',
    textFieldType: 'number',
    isTextArea: false,
    width: 6, // Half of the next row
    disabled: true,
  },
  {
    name: 'percentageOfSite',
    typeOfInp: 'input',
    label: 'Percentage of Site',
    textFieldType: 'number',
    isTextArea: false,
    width: 6, // Half of the next row
  },
];
let harvestingInputKeys = [
  {
    name: 'treeHeight',
    typeOfInp: 'input',
    label: 'Tree Height',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'volumePerWeekHarvestor',
    typeOfInp: 'input',
    label: 'Volume/Week (Harvester)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'volumePerWeekForwarder',
    typeOfInp: 'input',
    label: 'Volume/Week (Forwarder)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'roadorStackingArea',
    typeOfInp: 'input',
    label: 'Road or Stacking Area',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'extractionOver300meters',
    typeOfInp: 'input',
    label: 'Extraction Over 300m',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'restrictedAccess',
    typeOfInp: 'input',
    label: 'Restricted Access',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },

  // Tracks/Wheelchains
  {
    name: 'tracksWheelchains',
    typeOfInp: 'input',
    label: 'Tracks/Wheelchains',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'tracksWheelchainsPercent',
    typeOfInp: 'input',
    label: 'Tracks/Wheelchains (%)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'tracksWheelchainsDays',
    typeOfInp: 'input',
    label: 'Tracks/Wheelchains (Days)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },

  // Lowloader
  {
    name: 'lowloader',
    typeOfInp: 'input',
    label: 'Lowloader',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'lowloaderPercent',
    typeOfInp: 'input',
    label: 'Lowloader (%)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'lowloaderDays',
    typeOfInp: 'input',
    label: 'Lowloader (Days)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },

  // Digger Work
  {
    name: 'diggerWork',
    typeOfInp: 'input',
    label: 'Digger Work',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'diggerWorkPercent',
    typeOfInp: 'input',
    label: 'Digger Work (%)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'diggerWorkDays',
    typeOfInp: 'input',
    label: 'Digger Work (Days)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },

  // Chainsaw Work
  {
    name: 'chainsawWork',
    typeOfInp: 'input',
    label: 'Chainsaw Work',
    textFieldType: 'text',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'chainsawWorkPercent',
    typeOfInp: 'input',
    label: 'Chainsaw Work (%)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },
  {
    name: 'chainsawWorkDays',
    typeOfInp: 'input',
    label: 'Chainsaw Work (Days)',
    textFieldType: 'number',
    isTextArea: false,
    width: 4,
  },

  // Thinning Notes & Trees Per Hct
  {
    name: 'thinning1_TreesPerHct',
    typeOfInp: 'input',
    label: 'Thinning 1 - Trees/Ha',
    textFieldType: 'number',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'thinning1_Note',
    typeOfInp: 'input',
    label: 'Thinning 1 - Note',
    textFieldType: 'text',
    isTextArea: true,
    width: 6,
  },
  {
    name: 'thinning2_TreesPerHct',
    typeOfInp: 'input',
    label: 'Thinning 2 - Trees/Ha',
    textFieldType: 'number',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'thinning2_Note',
    typeOfInp: 'input',
    label: 'Thinning 2 - Note',
    textFieldType: 'text',
    isTextArea: true,
    width: 6,
  },
  {
    name: 'thinning3_TreesPerHct',
    typeOfInp: 'input',
    label: 'Thinning 3 - Trees/Ha',
    textFieldType: 'number',
    isTextArea: false,
    width: 6,
  },
  {
    name: 'thinning3_Note',
    typeOfInp: 'input',
    label: 'Thinning 3 - Note',
    textFieldType: 'text',
    isTextArea: true,
    width: 6,
  },
];
const formatName = str => {
  if (!str) return;
  return str.charAt(0).toUpperCase() + (str.length >= 2 && str.slice(1));
};

const EditSiteTableData = ({ open, setOpen, sectionName, sectionData, handleEditSave, subCompartments }) => {
  const [formData, setFormData] = useState(sectionData);
  const { products } = useGetProductDropdown();
  const species = useGetSpeciesDropdown();
  const destinations = useDestinationDropdown();
  const { sageCustomers, getCustomerCode } = useSageCustomers();

  const infoDropdownFields = infoOptionInputKeys.filter(input => input.name !== 'urea').map(input => input.name);

  const { dropdowns: infoDropdowns, loading: loadingDropdowns } = useInfoDropdowns(infoDropdownFields);

  const { dropdown: hazardDropdown } = useHazrdsDropdown();

  // console.log(hazardDropdown);

  const handleChange = (key, value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };
  const handleClose = () => {
    setFormData({});
    setOpen(false);
  };

  const handleSave = () => {
    console.log(formData, 'formData');

    let payload = { ...formData };
    if (sectionName === 'products') {
      const code = getCustomerCode(payload.customerName);
      payload = {
        ...payload,
        customerCode: code,
      };
    }

    handleEditSave(sectionName, { ...payload });
  };
  useEffect(() => {
    console.log(sectionData);
    if (open) {
      setFormData(sectionData);
    }
  }, [sectionData, open]);

  const getInputArrayList = () => {
    if (sectionName == 'checklist') {
      return checkListInputKeys;
    } else if (sectionName === 'info') {
      return infoOptionInputKeys;
    } else if (sectionName === 'siteVolume') {
      return siteVolumeOptionInputKeys;
    } else if (sectionName === 'geolocations') {
      return geoLocationInputKeys;
    } else if (sectionName === 'harvesting') {
      return harvestingInputKeys;
    } else if (sectionName === 'hazards') {
      return hazardsInputKeys;
    } else if (sectionName === 'products') {
      return productsInputKeys;
    } else if (sectionName === 'species') {
      return speciesInputKeys;
    } else {
      return [];
    }
  };
  return (
    <Dialog maxWidth="xl" open={open} onClose={handleClose} disableEscapeKeyDown={true}>
      <DialogTitle>
        <Typography style={{ fontSize: '1.5rem' }} component="div">
          {' '}
          Edit {formatName(sectionName)}
        </Typography>
      </DialogTitle>
      <DialogContent style={{ width: '60vw' }}>
        <Box
          noValidate
          component="div"
          className="SiteInfoDialog"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            m: 'auto',
            width: '100%',
            gap: '1rem',
          }}>
          <Grid container spacing={5}>
            {getInputArrayList().map((inputProps, index) => (
              <Grid item xs={12} sm={6} md={inputProps.width || 4} key={`${inputProps.name}_${index}`}>
                {console.log('Form value for', inputProps.name, ':', formData[inputProps.name])}
                {inputProps.typeOfInp === 'select' && (
                  <TextField
                    variant="outlined"
                    required={inputProps.required}
                    select
                    fullWidth
                    size="small"
                    label={inputProps.label}
                    value={formData[inputProps.name] ?? ''}
                    disabled={inputProps.disabled}
                    onChange={e => handleChange(inputProps.name, e.target.value)}
                    SelectProps={{
                      MenuProps: {
                        disablePortal: true,
                        anchorOrigin: {
                          vertical: 'bottom',
                          horizontal: 'left',
                        },
                        transformOrigin: {
                          vertical: 'top',
                          horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                      },
                    }}>
                    {console.log('IP NAME ==============', inputProps.name)}
                    {inputProps.name === 'products' && Array.isArray(products)
                      ? products.map(item => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))
                      : inputProps.name === 'subCompartmentName' && Array.isArray(subCompartments)
                      ? subCompartments.map(item => (
                          <MenuItem key={item.mapLabel} value={item.mapLabel}>
                            <Box display="flex" flexDirection="column">
                              <Typography variant="body1">{item.displayName}</Typography>
                              <Typography variant="caption" color="text.secondary">
                                {item.mapLabel}
                              </Typography>
                            </Box>
                          </MenuItem>
                        ))
                      : inputProps.name === 'species' && Array.isArray(species)
                      ? species.map(item => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))
                      : inputProps.name === 'productsDestination' && Array.isArray(destinations)
                      ? destinations.map(item => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))
                      : inputProps.name === 'customerName' && Array.isArray(sageCustomers)
                      ? sageCustomers.map(item => (
                          <MenuItem key={item} value={item}>
                            {item}
                          </MenuItem>
                        ))
                      : (inputProps.dropDownData || infoDropdowns[inputProps.name] || hazardDropdown[inputProps.name])?.map(
                          opt => (
                            <MenuItem key={opt.value} value={opt.value}>
                              {opt.label}
                            </MenuItem>
                          ),
                        )}
                  </TextField>
                )}
                {inputProps.typeOfInp == 'input' && (
                  <TextField
                    variant="outlined"
                    type={inputProps.textFieldType || 'text'}
                    fullWidth
                    size="small"
                    label={inputProps.label}
                    value={formData[inputProps.name] ?? ''}
                    disabled={inputProps.disabled}
                    onChange={e => handleChange(inputProps.name, e.target.value)}
                    multiline={inputProps.isTextArea}
                    InputLabelProps={{ shrink: true }}
                  />
                )}
                {/* </FormControl> */}
              </Grid>
            ))}
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="contained" color="primary" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditSiteTableData;
